import Insurance from 'screens/Insurance/Insurance';

export default Insurance;
